<template>
  <div class="hospital-page">
    <a-card :bordered="false" class="panel">
      <div class="toolbar">
        <a-input-search
          v-model="query.keyword"
          allow-clear
          placeholder="搜索医院名/院区/地址"
          style="width: 300px"
          @search="onSearch"
        />
        <a-button type="primary" icon="plus" @click="openCreate">新增医院</a-button>
      </div>

      <a-table
        rowKey="id"
        :columns="columns"
        :dataSource="list"
        :loading="loading"
        :pagination="false"
      >
        <template slot="state" slot-scope="text">
          <a-tag :color="Number(text) === 0 ? 'green' : 'default'">
            {{ Number(text) === 0 ? "启用" : "停用" }}
          </a-tag>
        </template>
        <template slot="action" slot-scope="text, record">
          <span>
            <a @click="openEdit(record)">编辑</a>
            <a-divider type="vertical" />
            <a-popconfirm title="确定删除该医院吗？" @confirm="remove(record)">
              <a style="color: #ff4d4f">删除</a>
            </a-popconfirm>
          </span>
        </template>
      </a-table>

      <div class="pager">
        <a-pagination
          :current="query.current"
          :pageSize="query.size"
          :total="total"
          show-size-changer
          :pageSizeOptions="['10', '20', '50', '100']"
          :showTotal="(t) => `共 ${t} 条`"
          @change="onPageChange"
          @showSizeChange="onSizeChange"
        />
      </div>
    </a-card>

    <a-modal
      :visible="visible"
      :title="form.id ? '编辑医院' : '新增医院'"
      :confirmLoading="saving"
      @ok="submit"
      @cancel="visible = false"
    >
      <a-form-model ref="formRef" :model="form" :rules="rules" :labelCol="{ span: 5 }" :wrapperCol="{ span: 19 }">
        <a-form-model-item label="医院名称" prop="hospitalName">
          <a-input v-model="form.hospitalName" placeholder="如：市一医院" />
        </a-form-model-item>
        <a-form-model-item label="院区" prop="branchType">
          <a-input v-model="form.branchType" placeholder="如：一院/二院、东院/西院" />
        </a-form-model-item>
        <a-form-model-item label="地址" prop="address">
          <a-input v-model="form.address" placeholder="请输入详细地址" />
        </a-form-model-item>
        <a-form-model-item label="联系人">
          <a-input v-model="form.contactName" placeholder="选填" />
        </a-form-model-item>
        <a-form-model-item label="联系电话">
          <a-input v-model="form.contactPhone" placeholder="选填" />
        </a-form-model-item>
        <a-form-model-item label="状态">
          <a-radio-group v-model="form.state">
            <a-radio :value="0">启用</a-radio>
            <a-radio :value="1">停用</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { dispatchApi } from "./dispatchApi";

const emptyForm = () => ({
  id: null,
  hospitalName: "",
  branchType: "",
  address: "",
  contactName: "",
  contactPhone: "",
  state: 0,
});

export default {
  name: "DispatchHospitals",
  data() {
    return {
      loading: false,
      saving: false,
      visible: false,
      list: [],
      total: 0,
      query: {
        keyword: "",
        current: 1,
        size: 10,
      },
      form: emptyForm(),
      columns: [
        { title: "医院名称", dataIndex: "hospitalName" },
        { title: "院区", dataIndex: "branchType", width: 160 },
        { title: "地址", dataIndex: "address" },
        { title: "联系人", dataIndex: "contactName", width: 110 },
        { title: "联系电话", dataIndex: "contactPhone", width: 140 },
        { title: "状态", dataIndex: "state", width: 90, scopedSlots: { customRender: "state" } },
        { title: "操作", key: "action", width: 120, scopedSlots: { customRender: "action" } },
      ],
      rules: {
        hospitalName: [{ required: true, message: "请输入医院名称", trigger: "blur" }],
        branchType: [{ required: true, message: "请输入院区信息", trigger: "blur" }],
        address: [{ required: true, message: "请输入医院地址", trigger: "blur" }],
      },
    };
  },
  created() {
    this.fetchList();
  },
  methods: {
    async fetchList() {
      this.loading = true;
      try {
        const data = await dispatchApi.pageHospitals(this.query);
        this.list = data.records || [];
        this.total = Number(data.total || 0);
      } catch (e) {
        this.$message.error((e && e.message) || "加载医院列表失败");
      } finally {
        this.loading = false;
      }
    },
    onSearch() {
      this.query.current = 1;
      this.fetchList();
    },
    onPageChange(page) {
      this.query.current = page;
      this.fetchList();
    },
    onSizeChange(page, size) {
      this.query.current = page;
      this.query.size = size;
      this.fetchList();
    },
    openCreate() {
      this.form = emptyForm();
      this.visible = true;
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate();
      });
    },
    openEdit(row) {
      this.form = {
        id: row.id,
        hospitalName: row.hospitalName || "",
        branchType: row.branchType || "",
        address: row.address || "",
        contactName: row.contactName || "",
        contactPhone: row.contactPhone || "",
        state: row.state == null ? 0 : Number(row.state),
      };
      this.visible = true;
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate();
      });
    },
    submit() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return;
        this.saving = true;
        try {
          if (this.form.id) {
            await dispatchApi.updateHospital(this.form.id, this.form);
            this.$message.success("医院信息已更新");
          } else {
            await dispatchApi.createHospital(this.form);
            this.$message.success("医院信息已新增");
          }
          this.visible = false;
          this.fetchList();
        } catch (e) {
          this.$message.error((e && e.message) || "保存失败");
        } finally {
          this.saving = false;
        }
      });
    },
    async remove(row) {
      try {
        await dispatchApi.deleteHospital(row.id);
        this.$message.success("已删除");
        if (this.list.length === 1 && this.query.current > 1) {
          this.query.current -= 1;
        }
        this.fetchList();
      } catch (e) {
        this.$message.error((e && e.message) || "删除失败");
      }
    },
  },
};
</script>

<style scoped>
.hospital-page {
  display: flex;
  flex: 1;
  min-height: 0;
  padding: 16px;
}

.panel {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  gap: 12px;
}

.pager {
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
}
</style>

